import { z } from 'zod';
export const CodeSchema = z.object({ code: z.string() }).describe('Code object with token');
//# sourceMappingURL=codeSchema.js.map